import * as React from "react";
import PropTypes from "prop-types";
import { Image, Text, tokens, makeStyles, Label } from "@fluentui/react-components";

const useStyles = makeStyles({
  component: {
    width: "100%",
  },
  grid: {
    display: "flex",
    flexDirection: "row",
  },
  col: {
    flex: 1,
    flexGrow: 1,
    marginBottom: tokens.spacingVerticalM,
  },
  label: {
    display: "block",
    color: tokens.colorBrandStroke1,
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    marginRight: tokens.spacingHorizontalSNudge,
  },
  textBlock: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    display: "block",
  },
});

const Overview = (props) => {
  const { data, domain, loading } = props;
  const styles = useStyles();

  return (
    <div className={styles.component}>
      <div className={styles.grid}>
        <section className={styles.col}>
          <Label size="small" className={styles.label}>
            Name
          </Label>
          <Text className={styles.text}>{data?.name ?? "-"}</Text>

          <Label size="small" className={styles.label}>
            Email
          </Label>
          <Text className={styles.text}>{data?.email ?? "-"}</Text>

          <Label size="small" className={styles.label}>
            Phone
          </Label>
          <Text className={styles.text}>{data?.phone ?? "-"}</Text>
        </section>
        <section className={styles.col}>
          <Label size="small" className={styles.label}>
            Ebay Username
          </Label>
          <Text className={styles.text}>
            {data?.ebay_username ? data.ebay_username : data.ebay_data?.BuyerUserID ?? "-"}
          </Text>
        </section>
      </div>
      <div className={styles.grid}>
        <section className={styles.col}>
          <Label size="small" className={styles.label}>
            Billing Address
          </Label>
          <Text className={styles.textBlock}>{data?.billing_address_1 ?? "-"}</Text>
          {data?.billing_address_2 && <Text className={styles.textBlock}>{data?.billing_address_2 ?? "-"}</Text>}
          <Text className={styles.textBlock}>{data?.billing_suburb ?? "-"}</Text>
          <Text className={styles.text}>{data?.billing_state ?? "-"}</Text>
          <Text className={styles.text}>{data?.billing_postcode ?? "-"}</Text>
          <Text className={styles.text}>{data?.billing_country ?? "-"}</Text>
        </section>
        <section className={styles.col}>
          <Label size="small" className={styles.label}>
            Shipping Address
          </Label>
          <Text className={styles.textBlock}>{data?.shipping_address_1 ?? "-"}</Text>
          {data?.shipping_address_2 && <Text className={styles.textBlock}>{data?.shipping_address_2 ?? "-"}</Text>}
          <Text className={styles.textBlock}>{data?.shipping_suburb ?? "-"}</Text>
          <Text className={styles.text}>{data?.shipping_state ?? "-"}</Text>
          <Text className={styles.text}>{data?.shipping_postcode ?? "-"}</Text>
          <Text className={styles.text}>{data?.shipping_country ?? "-"}</Text>
        </section>
      </div>
    </div>
  );
};

Overview.propTypes = {
  data: PropTypes.object,
};

export default Overview;
